import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import PageTitle from 'components/_base/PageTitle';

import ContentDraft from './ContentDraft';

const Draft = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <PageTitle title="Rascunhos" />
      <hr />
      <ContentDraft />
      <Bottom />
    </div>
  );
};

export default Draft;
